import {confirmAlert,} from "react-confirm-alert";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useState} from "react";
import {deletePage} from "../../api/page";
import Button from "../../components/UI/Button";
import {Link} from "react-router-dom";

const PageTableActions = ({row, editRecord}) =>{

  const [toastId, setToastId] = useState(null);

  const queryClient = useQueryClient()

  const {mutate, isPending} = useMutation({
    mutationFn: deletePage,
    onMutate: () => {
      setToastId(toast.loading("Please wait..."))
    },
    onSuccess: (response, payload) => {
      toast.update(toastId, { render: "Page Deleted!", type: "success", isLoading: false, autoClose: true  });
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'pages',
      });
    },
    onError: () => {
      toast.update(toastId, { render: "Something happened!", type: "error", isLoading: false, autoClose: true });
    }
  })

  const editHandler = ()=>{
    editRecord(row)
  }

  const deleteHandler = () => {
    confirmAlert({
      title: 'Delete',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            mutate({id: row.id})
          },
        },
        {
          label: 'No',
          onClick: () => {
            return;
          },
        }
      ]
    });
  }
  return (
    <>
      <Link to={`/pages/edit/${row.id}`}>
      <Button
        text="Edit"
        classes={"mr_5"}
        variant={"has_border_radius btn_transparent"}
        size={'btn_sm'}
        onClickHandler={editHandler}
      />
      </Link>
      <Button
        text="Delete"
        variant={"btn_danger"}
        isPending={isPending}
        classes={'btn_black has_border_radius'}
        size={'btn_sm'}
        onClickHandler={deleteHandler}
      />
    </>
  );
}

export default PageTableActions;